import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({
    site_name: "efsane.co",
    site_description: "Arkadaşlarınla Birlikte Film & YouTube İzle",
    banner_text: "",
    banner_link: "",
    banner_active: false,
    logo_url: "/logo.png",
  });

  const load = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      if (data.site_name) document.title = data.site_name;
    } catch {}
  };

  useEffect(() => {
    load();
  }, []);

  return <SiteContext.Provider value={{ settings, reload: load }}>{children}</SiteContext.Provider>;
}
